import { render, staticRenderFns } from "./MassUpdate.vue?vue&type=template&id=e2e5c854"
import script from "./MassUpdate.vue?vue&type=script&lang=js"
export * from "./MassUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports